import { render, staticRenderFns } from "./ContentDirectorySettings.vue?vue&type=template&id=00cb5948&scoped=true"
import script from "./ContentDirectorySettings.vue?vue&type=script&lang=js"
export * from "./ContentDirectorySettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00cb5948",
  null
  
)

export default component.exports